import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "petsAllowed",
    "eventsAllowed",
    "smokingAllowed",
    "quietHoursEnabled",
    "quietHoursFields",
    "quietHoursOff",
    "quietHoursOn",
    "commercialPhotographyAllowed"
  ]

  toggle(event) {
    const field = event.currentTarget.dataset.field
    const value = event.currentTarget.dataset.value
    const target = this[`${this.camelize(field)}Target`]

    if (target) {
      target.value = value
    }

    // Update button styles
    const parent = event.currentTarget.parentElement
    const buttons = parent.querySelectorAll("button")
    buttons.forEach(btn => {
      const isSelected = btn.dataset.value === value
      if (isSelected) {
        btn.classList.add("bg-slate-900", "border-slate-900", "text-white")
        btn.classList.remove("border-slate-300", "text-slate-400")
      } else {
        btn.classList.remove("bg-slate-900", "border-slate-900", "text-white")
        btn.classList.add("border-slate-300", "text-slate-400")
      }
    })
  }

  toggleQuietHours(event) {
    const value = event.currentTarget.dataset.value
    this.quietHoursEnabledTarget.value = value

    // Update button styles
    if (value === "true") {
      this.quietHoursOnTarget.classList.add("bg-slate-900", "border-slate-900", "text-white")
      this.quietHoursOnTarget.classList.remove("border-slate-300", "text-slate-400")
      this.quietHoursOffTarget.classList.remove("bg-slate-900", "border-slate-900", "text-white")
      this.quietHoursOffTarget.classList.add("border-slate-300", "text-slate-400")
      this.quietHoursFieldsTarget.classList.remove("hidden")
    } else {
      this.quietHoursOffTarget.classList.add("bg-slate-900", "border-slate-900", "text-white")
      this.quietHoursOffTarget.classList.remove("border-slate-300", "text-slate-400")
      this.quietHoursOnTarget.classList.remove("bg-slate-900", "border-slate-900", "text-white")
      this.quietHoursOnTarget.classList.add("border-slate-300", "text-slate-400")
      this.quietHoursFieldsTarget.classList.add("hidden")
    }
  }

  camelize(str) {
    return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
  }
}
